import { render, staticRenderFns } from "./OpenAndOverdueMovements.vue?vue&type=template&id=1daf8a35&"
import script from "./OpenAndOverdueMovements.vue?vue&type=script&lang=js&"
export * from "./OpenAndOverdueMovements.vue?vue&type=script&lang=js&"
import style0 from "./OpenAndOverdueMovements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDataTable,VIcon,VList,VListItem,VMenu})
